// install (please make sure versions match peerDependencies)
// yarn add @nivo/core @nivo/line
import axios from 'axios';
import { useEffect, useState } from 'react';
import { format, isValid } from 'date-fns';
import { ResponsiveLine } from '@nivo/line';
import { apiEndpoint } from '../constants/api';

// make sure parent container have a defined height when using
// responsive component, otherwise height will be 0 and
// no chart will be rendered.
// website examples showcase many properties,
// you'll often use just a few of them.
export const JobSubmissionLineChart = ({ employer }) => {
  const [chartData, setChartData] = useState([]);

  const loadJobApps = async () => {
    if(employer){
    const { data } = await axios.get(apiEndpoint(`/analytics/job/apps/${employer}`));
    setChartData([
      {
        id: 'Applications',
        color: '',
        data: data.map((j) => (
          { x: new Date(j.apps_submitted),
          y: j.count })),
      },
    ]);
    }
  };

  useEffect(() => {
    loadJobApps();
  }, [employer]);

  return (
    <ResponsiveLine
      data={chartData}
      margin={{ top: 10, right: 110, bottom: 20, left: 60 }}
      xScale={{ type: 'time', useUTC: false }}
      yScale={{
        type: 'linear',
        min: 'auto',
        max: 'auto',
      }}
      axisTop={null}
      axisRight={null}
      axisBottom={{
        orient: 'bottom',
        legend: 'category',
        legendOffset: 36,
        legendPosition: 'middle',
        tickValues: 5,
        format: '%b %d'
      }}
      axisLeft={{
        orient: 'left',
        legend: 'Submissions',
        legendOffset: -50,
        legendPosition: 'middle',
      }}
      curve="cardinal"
      pointSize={5}
      lineWidth={4}
      pointColor={{ theme: 'background' }}
      pointBorderWidth={2}
      pointBorderColor={{ from: 'serieColor' }}
      pointLabelYOffset={-12}
      useMesh={true}
      legends={[
        {
          anchor: 'bottom-right',
          direction: 'column',
          justify: false,
          translateX: 100,
          translateY: 0,
          itemsSpacing: 0,
          itemDirection: 'left-to-right',
          itemWidth: 80,
          itemHeight: 20,
          itemOpacity: 0.75,
          symbolSize: 12,
          symbolShape: 'circle',
          symbolBorderColor: 'rgba(0, 0, 0, .5)',
          effects: [
            {
              on: 'hover',
              style: {
                itemBackground: 'rgba(0, 0, 0, .03)',
                itemOpacity: 1,
              },
            },
          ],
        },
      ]}
      tooltip={function (e) {
        return `${format(new Date(e.point.data.xFormatted), 'MMM dd, yyyy')}: ${e.point.data.yFormatted}`;
      }}
    />
  );
};
